module.exports = __webpack_public_path__ + "img/logoTeros.6030b4c2.png";